import Vue from 'vue';
import { InstallationState } from '.';
import { AsyncMutationTree } from 'vuex-async-mutations';

export const mutationsAsync: AsyncMutationTree<InstallationState> = {};
